module.exports = __webpack_public_path__ + "static/media/p5.7a0fa8ce.svg";